export type Draft = {
  id: number;
  name: string;
  owner_id: number;
  created_at: string;
  updated_at: string;
  allow_comment: boolean;
  allow_public: boolean | null;
  deleted: boolean;
  draft_size: number;
  draft_type: DraftType;
  width: number;
  height: number;
  unread: boolean;
  short_link: string;
  file: DraftFile | null | undefined;
  image: DraftImage | null | undefined;
  project_name?: string;
  project_short_link?: string;
  project_id?: number;
  workspace_name?: string;
  workspace_short_link?: string;
  workspace_id?: number;
};

export type DraftImage = {
  original_url: string;
  blur_url: string;
  thumb_url: string;
};

export type DraftFile = {
  original_url: string;
  mp4_480p?: string;
};

export enum DraftType {
  image = 'image',
  video = 'video',
  file = 'file',
}
